import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import TreeView from '@material-ui/lab/TreeView';
import Typography from '@material-ui/core/Typography';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import FolderIcon from '@material-ui/icons/Folder';
import Button, { ButtonMore, ModalButton } from '../components/Button';
import { Scrollbar, theme, UIComponent, View } from './Base';
import { createIcon, Request, toByteSize, Notification, Util, runtime, Config } from '../common';
import StorageIcon from '@material-ui/icons/Storage';
import { SemiTPanel, SearchBar } from './Layout';
import CreateNewFolderIcon from '@material-ui/icons/CreateNewFolder';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from "@material-ui/core/ListItemText";
import { CircularProgress, DialogActions, IconButton, Divider } from '@material-ui/core';
import { Alert } from 'reactstrap';
import { Loading } from './Backdrop';
import DataGrid from './dataGrid/index';
import Modal, { Message } from './Modal';
import Form, { FormCell, FormAction } from './Form';
import { TextBox } from './TextBox';
import ReplyIcon from '@material-ui/icons/Reply';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import Upload from './Upload';
import GetAppIcon from '@material-ui/icons/GetApp';
import { isWXOrQQ } from 'codeArt/weChat';
import Copy from 'copy-to-clipboard';
import { encode } from 'base-64';
import SwapVertIcon from '@material-ui/icons/SwapVert';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { TreeItem, TreeLoading } from './Tree'
import FolderOpenIcon from '@material-ui/icons/FolderOpen';
import { permissionCodes as pc } from 'js/auth';

export let ExplorerConfig = new Config();

export class Explorer extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      root: null,
      directory: null,
      loading: true,
      selectCount: 0,
      path: []
    };
  }


  handleCreateDirectory() {
    this.refs.createDirectoryModal.open();
  }

  closeCreateDirectory() {
    this.refs.createDirectoryModal.close();
  }

  handleSubmitCreateDirectory() {
    let my = this;
    let url = this.props.createDirectory || ExplorerConfig.createDirectory;
    let { root, directory } = this.state;
    var form = this.refs.createDirectory;
    form.submit({
      url: url,
      data: { rootId: root.Id, directoryId: directory.Id },
      success: (r) => {
        my.reload();
        my.closeCreateDirectory();
        Notification.success("已新建目录");
      }
    });
  }

  commandHeader() {
    let { selectCount } = this.state;
    let { picker, permission } = this.props;

    return (
      <div className="row">
        <div className="col-md-12 col-xs-12 d-flex flex-row justify-content-end">
          <p className="c-selected d-flex justify-content-center align-items-center c-text-s1 c-text-sm-s2 mb-0 mr-3">{`已选择 ${selectCount} 项`}</p>
          {selectCount == 1 && this.get()[0].Type == 2 ? <Button permission={permission.download} color="purple" icon={GetAppIcon} onClick={() => this.download()}>下载</Button> : null}
          {selectCount == 1 ? <Button permission={permission.rename} color="warning" icon={EditIcon} onClick={() => this.rename()} className="ml-2">重命名</Button> : null}
          {/*        {selectCount == 1 ? <Button color="teal" icon={AutorenewIcon} className="ml-2" onClick={() => { Message.alert("该功能建设中"); }}>替换</Button> : null} */}
          <Button permission={permission.move} color="blue" icon={SwapVertIcon} onClick={() => this.move()} className={selectCount == 1 ? "ml-2" : ""}>移动</Button>
          <Button permission={permission.delete} color="danger" icon={DeleteIcon} onClick={() => this.delete()} className="ml-2">删除</Button>
        </div>
      </div>
    )
  }

  commonHeader() {
    let { picker, permission } = this.props;
    return (
      <div className="row">
        <div className="col-md-5 col-xs-12 d-flex flex-row">
          <SearchBar placeholder="搜索" field="name" slave="explorerItems" onChange={() => { this.reload(); }} />
        </div>
        <div className="col-md-7 col-xs-12">
          <View className="d-flex flex-row justify-content-end align-items-center h-100">
            <div>
              <Button permission={permission.folder} color="blue" icon={CreateNewFolderIcon} onClick={() => this.handleCreateDirectory()}>新建文件夹</Button>
              <Button permission={permission.upload} color="green" icon={CloudUploadIcon} onClick={() => this.handleOpenUpload()} className="ml-2">上传文件</Button>
            </div>
          </View>
        </div>
      </div>
    )
  }

  handleOpenUpload() {
    this.refs.uploadModal.open();
  }

  closeUpload(cancel) {
    if (cancel !== false) {
      this.refs.uploadFile.cancel();
    }
    this.refs.uploadModal.close();
  }

  header() {
    let { selectCount } = this.state;
    return (
      selectCount === 0 ? this.commonHeader() : this.commandHeader()
    )
  }

  side() {
    let { roots, root: current, path } = this.state;
    roots = roots || [];
    return (
      <List>
        {
          roots.map((root, i) => {
            let selected = current ? (current.Id == root.Id) : null;
            return (
              <ListItem className="c-py-2d5" button key={i} selected={selected}>
                {selected ? <FolderOpenIcon className="mr-2" /> : <FolderIcon className="mr-2" />}
                <p className="mb-0 c-text-s1d5">{root.Name}</p>
              </ListItem>)
          })
        }
        {
          path.length > 1 ?
            <ListItem className="c-py-2d5" button onClick={() => { this.handleBack() }}>
              <ReplyIcon className="mr-2" />
              <p className="mb-0 c-text-s1d5">返回上一级</p>
            </ListItem>
            : null
        }
      </List>
    )
  }


  loadRoots() {
    var my = this;
    let url = this.props.getRoots || ExplorerConfig.getRoots;
    Request({
      url: url,
      before: () => {

      },
      success: (r) => {
        if (my._unmount) return;
        my.setState({
          roots: r.Roots
        });
        let root = r.Roots[0];
        if (root)
          my.loadRoot(root);
      },
      complete: () => {
        if (my._unmount) return;
        my.setState({
          loading: false
        });
      }
    });
  }

  renderLoading() {
    return (
      <div className="c-mask" style={{ background: "rgba(0,0,0,0)", justifyContent: "center", alignItems: "center" }}>
        <Loading message="加载中" />
      </div>)
  }

  componentDidMount() {
    this.loadRoots();
  }

  componentWillUnmount() {
    this._unmount = true;
  }

  loadRoot(root) {
    this.setState({ root }, () => {
      this.push(root);
      this.loadDirectory(root);
    });
  }

  loadDirectory(directory) {
    this.setState({ directory }, () => {
      this.refs.items.load();
    });
  }

  push(directory) {
    let { path } = this.state;
    path.push(directory);
    this.setState({ path });
  }

  pop() {
    let { path } = this.state;
    path.pop();
    var data = path[path.length - 1];
    this.setState({ path });
    return data;  //返回最后一个
  }

  handleBack() {
    this.clearSelect();
    var data = this.pop();
    this.loadDirectory(data);
  }


  reload() {
    this.refs.items.load();
  }

  queryItems() {
    let { directory } = this.state;
    let data = {};
    if (directory) data.directoryId = directory.Id;
    return data;
  }

  radio() {
    let { readonly, multiple } = this.props;
    if (readonly) return false;
    return !multiple;
  }

  checkbox() {
    let { readonly, multiple } = this.props;
    if (readonly) return false;
    return multiple;
  }

  handleSelect(data) {
    if (data.Extension == "dir") {
      this.enterDirectory(data);
      return false; //表示不勾选
    }
  }

  selectChanged(items) {
    //选择了文件，触发事件
    let { onSelectChanged } = this.props;
    if (onSelectChanged)
      onSelectChanged(items);
  }

  enterDirectory(data) {
    this.clearSelect();
    //进入目录
    this.push(data);
    this.loadDirectory(data);
  }

  clearSelect() {
    var table = this.refs.items;
    table.reset();
    this.setState({ selectCount: 0 });
  }

  handleSelected(data) {
    var table = this.refs.items;
    this.setState({
      selectCount: table.get().length
    });
  }

  delete() {
    var my = this;
    Message.sweetConfirm({
      title: "确定删除所选项吗？",
      okText: "确定",
      cancelText: "取消",
      onOk: () => {
        my._delete();
      },
    });
  }

  _delete() {
    let { root, directory } = this.state;
    var items = this.get();
    let my = this;
    Request({
      url: this.props.delete || ExplorerConfig.delete,
      data: { rootId: root.Id, directoryId: directory.Id, items },
      success: (r) => {
        Notification.success("操作成功");
        my.clearSelect();
        my.reload();
      }
    });
  }

  move() {
    let { root } = this.state;
    let items = this.get();
    this.refs.moveModal.open(root.Id, items);
  }

  rename() {
    let { root, directory } = this.state;
    var item = this.get()[0];
    let my = this;
    this.refs.renameModal.open({
      onEntered: () => {
        my.refs.rename.accept(item);
      }
    });
  }

  download() {
    var item = this.get()[0];
    download(item);
  }

  closeRename() {
    this.refs.renameModal.close();
  }

  handleSubmitRename() {
    let { root } = this.state;
    let my = this;
    var form = my.refs.rename;
    form.submit({
      url: this.props.rename || ExplorerConfig.rename,
      data: { rootId: root.Id },
      success: (r) => {
        Notification.success("操作成功");
        my.closeRename();
        my.reload();
      }
    });
  }

  get() {
    var table = this.refs.items;
    var data = table.get();
    return Util.select(data, (item) => { return { Id: item.value, Name: item.text, Type: item.extension == "dir" ? 1 : 2, StoreKey: item.storeKey, Extension: item.extension } }); //目录类型为1，文件的类型为2
  }

  getFiles() {
    var items = Util.where(this.get(), (t) => t.Type == 2);
    let { accept } = this.props;
    let l = accept.split(',').map((t) => t.trim());
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (l.indexOf(item.Extension) == -1 && l.indexOf('.' + item.Extension) == -1) {
        Message.alert(`仅接受${accept}类型的文件`);
        return;
      }
    }
    return items;
  }

  onUploaded() {
    Notification.success("文件已上传");
    this.reload();
    this.closeUpload(false);
  }

  drawerBtn() {
    let { path } = this.state;
    if (runtime.pc) return;
    return (
      path.length > 1 ?
        <IconButton className="drawer-btn" onClick={() => { this.handleBack() }}>
          <ReplyIcon className="zmdi" />
        </IconButton> : null
    )
  }

  getExtension(v) {
    switch (v) {
      case "png":
      case "jpg":
      case "jpeg": return "图片";
      case "gif": return "动态图片";
      case "rar":
      case "7z":
      case "zip": return "压缩文件";
      case "dir": return "文件夹";
      case "txt": return "文本文档";
      case "doc":
      case "docx": return "Word文档";
      case "xlsx":
      case "xls": return "Excel工作表";
      case "pptx":
      case "ppt": return "PPT演示文稿";
      case "pdf": return "PDF便携式文档";
    }

    return v;
  }

  render() {
    let { style, getItems, accept, moveFiles, getVirtualDirectory } = this.props;
    let { loading, directory } = this.state;
    let url = getItems || ExplorerConfig.getItems;

    return (
      <div className="c-explorer h-100">
        <SemiTPanel title={"文件管理器"} icon={StorageIcon} header={this.header()} side={this.side()} drawerBtn={this.drawerBtn()}>
          <DataGrid scrollable={true} className="p-3" ref="items" searchMaster="explorerItems" action={url} emptyText="暂无数据" pageSize={25} checkbox={this.checkbox()} radio={this.radio()} lazy={true} keyColumn={{ value: "Id", text: "Name", extension: "Extension", storeKey: "StoreKey" }}
            getParams={this.queryItems.bind(this)}
            columns={[
              { mobile: { width: "auto", ellipsis: false }, field: "Name", label: "名称", align: "left", component: (data) => { return thumbLayout(data); } },
              { field: "QuoteCount", label: "引用", align: "center", width: "80px", component: (data) => { return quoteCountTemplate(data); } },
              { field: "CreateTime", label: "创建时间", align: "center", width: "180px" },
              { field: "Extension", label: "类型", align: "center", width: "150px", component: (data) => { return this.getExtension(data.Extension); } },
              { field: "Size", label: "大小", align: "center", width: "150px", component: (data) => { return toByteSize(data.Size); } }
            ]}
            onRowSelect={(data) => { return this.handleSelect(data); }}
            onRowSelected={(data, selected) => { this.handleSelected(data, selected); }}
            onBoxSelected={(data) => { this.handleSelected(data); }}
            onAllRowSelected={(data) => this.handleSelected(data)}
            selectChanged={(items) => this.selectChanged(items)}
          />
        </SemiTPanel>
        {loading ? this.renderLoading() : null}
        <MoveModal ref="moveModal" moveFiles={moveFiles} getVirtualDirectory={getVirtualDirectory} onChange={() => { this.clearSelect(); this.reload(); }} />

        <Modal title={"新建文件夹"} ref="createDirectoryModal" size="md" >
          <Form ref="createDirectory" className={Form.modalClassName} submitMaster="createDirectory" alert={false}>
            <FormCell size={12}>
              <TextBox field="name" label="文件夹名称" type="text" slave="createDirectory" required={true} minlength={1} maxlength={256} />
            </FormCell>
            <FormAction>
              <Button className={FormAction.modalFirstButtonClassName} size="lg" color="primary" onClick={() => { this.handleSubmitCreateDirectory(); }}>
                确定提交
              </Button>
              <Button className={FormAction.modalButtonClassName} size="lg" color="grey" onClick={() => { this.closeCreateDirectory() }}>
                取消
              </Button>
            </FormAction>
          </Form>
        </Modal>

        <Modal title={"重命名"} ref="renameModal" size="md">
          <Form ref="rename" className={Form.modalClassName} submitMaster="rename" alert={false}>
            <TextBox field="id" type="hidden" slave="rename" />
            <TextBox field="type" type="hidden" slave="rename" />
            <FormCell size={12}>
              <TextBox field="name" label="名称" type="text" slave="rename" required={true} minlength={1} maxlength={256} />
            </FormCell>
            <FormAction>
              <Button className={FormAction.modalFirstButtonClassName} size="lg" color="primary" onClick={() => { this.handleSubmitRename(); }}>
                确定提交
                </Button>
              <Button className={FormAction.modalButtonClassName} size="lg" color="secondary" onClick={() => { this.closeRename() }}>
                取消
                </Button>
            </FormAction>
          </Form>
        </Modal>

        <Modal title={"上传文件"} ref="uploadModal" size="md" showClose={false}>
          <Form ref="upload" submitMaster="upload" className={Form.modalClassName} alert={false}>
            <FormCell size={12} className="c-mb-3 c-mb-md-0">
              <Upload ref="uploadFile" field="file" slave="upload"
                maxSize={100}
                multiple={true}
                required={true}
                directoryId={directory ? directory.Id : ''}
                onUploaded={() => { this.onUploaded(); }}
                accept={accept} />
            </FormCell>
            <FormAction>
              <Button color="grey" onClick={() => { this.closeUpload() }} size="lg" className={FormAction.modalFirstButtonClassName}>
                关闭
                </Button>
            </FormAction>
          </Form>
        </Modal>
      </div>
    )
  }
}

Explorer.defaultProps = {
  multiple: true,
  accept: ".png,.jpg,.jpeg,.gif,.rar,.7z,.zip,.doc,.docx,.pdf,.ppt,.pptx,.xlsx,.xls,.txt",
  roots: [],
  permission: {},
}

export function thumbLayout(data) {
  var src = getSrc(data, 100, 100);
  return (
    <View className="d-flex flex-row justify-content-start align-items-center">
      <View>
        {src ? <img src={src} className="c-thumb" /> : null}
      </View>
      <View className="c-wrap">{data.Name}</View>
    </View>
  );
}

function quoteCountTemplate(data) {
  if (data.QuoteCount == 0) return '-';
  return <font className="text-red">{data.QuoteCount}</font>
}

export function isImage(e) {
  e = e.toLowerCase();
  switch (e) {
    case "bmp":
    case "png":
    case "gif":
    case "jpg":
    case "jpeg": return true;
  }
  return false;
}

export function getSrc(data, width, height) {
  if (!data) return '';
  if (!data.StoreKey && data.Extension != "dir") return '';
  let extension = data.Extension || data.StoreKey.split('.')[1];
  return isImage(extension) ? `${ExplorerConfig.domain}/image.htm?w=${width || 0}&h=${height || 0}&c=2&key=${data.StoreKey}&q=80` : `${ExplorerConfig.domain}/images/explorer/${extension}.png`;
}

export function parseSrc(src) {
  var matches = /\?w=(\d+)&h=(\d+)&c=(\d+)&key=(.+)&q=(\d+)/.exec(src);
  if (matches) {
    let Width = matches[1];
    let Height = matches[2];
    let CutType = matches[3];
    let StoreKey = matches[4];
    let Quality = matches[5];
    var temp = StoreKey.split('.');
    let Extension = temp[1];
    return { Extension, StoreKey, Width, Height };
  }
  return null;
}

export function download(data) {
  let url = getFile(data);
  if (isWXOrQQ()) {
    Downloader.current.open({ url });
    return;
  }

  const a = document.createElement('a');
  document.body.appendChild(a);
  a.style.display = 'none';
  a.href = url;
  a.click();
  document.body.removeChild(a);
}

export function parseFile(url) {
  var matches = /\?key=(.+)&name=(.+)/.exec(url);

  if (matches) {
    let StoreKey = matches[1];
    let Name = decodeURI(matches[2]);
    var temp = StoreKey.split('.');
    let Extension = temp[1];
    return { Extension, StoreKey, Name };
  }

  return null;
}

export function getFile(data) {
  let extension = data.Extension || '.' + data.StoreKey.split('.')[1];
  let name = data.Name.endsWith(extension) ? data.Name : `${data.Name}.${extension}`;
  let url = `${ExplorerConfig.domain}/file.htm?key=${data.StoreKey}&name=` + encodeURI(name);
  return url;
}


export class Downloader extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      title: "",
      url: "",
      help: ""
    }
    Downloader.current = this;
  }

  open({ url, title, help }) {
    let my = this;
    this.refs.modal.open({
      onEntered: () => {
        my.setState({
          url,
          title,
          help
        });
      }
    });
  }

  close() {
    this.setState({
      title: '',
      url: '',
      help: '',
    }, () => {
      this.refs.modal.close();
    })
  }

  copy() {
    let { url } = this.state;
    if (Copy(url)) {
      Notification.success("复制成功");
    } else {
      Notification.error("复制失败");
    }
  }

  render() {
    let { url, title, help } = this.state;
    return (
      <Modal title={title || "下载提示"} ref="modal" size="md" tools={
        [
          <ModalButton color="blue" key={0} onClick={() => { this.copy(); }}>复制链接</ModalButton>,
          <ModalButton color="grey" key={2} onClick={() => { this.close(); }}>取消</ModalButton>
        ]
      }>
        <Form className={Form.modalClassName} ref="downloader" submitMaster="downloader" alert={false}>
          <FormCell size={12}>
            <div className="d-flex flex-column">
              <p className="mb-1 c-text-s2 m-text-dark-75">{"地址"}</p>
              <p className="mb-1 c-text-s1 m-text-dark-75 c-wrap">{url}</p>
              <Divider />
              <p className="mt-1 c-text-s1 m-text-muted">{help || "目前尚不支持微信浏览器下载，请用其他浏览器或电脑端打开"}</p>
            </div>
            {/*   <TextBox field="link" value={url} label="链接" type="text" slave="downloader" disabled={true} help={help || "目前尚不支持微信浏览器下载，请用其他浏览器或电脑端打开"} /> */}
          </FormCell>
        </Form>


      </Modal>
    );
  }

}

// Folders


// MoveModal
export class MoveModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      data: {},
      moves: [],
      selectId: null,
      rootId: null,
    }
  }

  open(diskId, moves) {
    let my = this;
    Request({
      url: this.props.getRootDirectory || ExplorerConfig.getRootDirectory,
      data: { diskId: diskId, Directory: true },
      success: (r) => {
        my.setState({
          data: r,
          moves: moves,
          selectId: null,
          rootId: r.Id,
        }, () => {
          my.refs.modal.open();
        })
      }
    });
  }

  close() {
    this.refs.modal.close();
  }

  submit() {
    let { selectId, moves } = this.state;
    let { onChange } = this.props;
    if (!selectId) {
      Notification.error("请选择目录");
      return;
    }

    let ids = moves.map((t) => t.Id);
    Request({
      url: this.props.moveFiles || ExplorerConfig.moveFiles,
      data: { DirectoryId: selectId, ids: ids },
      success: (r) => {
        this.close();
        Notification.success("提交成功");
        if (onChange) onChange();
      }
    });

  }

  render() {
    let { data, rootId } = this.state;
    let items = data.Childs || [];
    return (
      <Modal title={"移动 - 选择目录"} ref="modal" size="sm" tools={
        [
          <ModalButton color="blue" key={0} onClick={() => { this.submit(); }}>确定</ModalButton>,
          <ModalButton color="grey" key={2} onClick={() => { this.close(); }}>取消</ModalButton>
        ]
      }>

        <Form className={Form.modalClassName} ref="moveForm" submitMaster="moveForm" alert={false}>
          <FormCell size={12}>
            <Folders data={items} getVirtualDirectory={this.props.getVirtualDirectory} rootId={rootId} onClick={(id) => { this.setState({ selectId: id }) }} />
          </FormCell>
        </Form>
      </Modal>
    );
  }

}

class Folders extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  getChilds(id) {
    Request({
      url: this.props.getVirtualDirectory || ExplorerConfig.getVirtualDirectory,
      data: { id: id },
      before: () => { },
      complete: () => { },
      success: (r) => {
        this.mergeData(id, r.Childs || [], r.ChildCount);
      }
    });
  }

  mergeData(fatherId, childs, childCount) {
    let { data } = this.props;
    let { items } = this.state;
    items = items || data || [];

    this.loopItems(items, fatherId, childs, childCount);
    this.setState({
      items
    })
  }

  loopItems(items, fatherId, childs, childCount) {
    items.forEach((t) => {
      if (t.Id == fatherId) {
        t.Childs = childs;
        t.ChildCount = childCount
      }
      if (t.Childs) {
        this.loopItems(t.Childs, fatherId, childs, childCount);
      }
    })
  }

  onClick(childs, count, id) {
    let { onClick } = this.props;
    if (Util.empty(childs) && count) this.getChilds(id);
    if (onClick) onClick(id);
  }

  renderItems(items) {
    return (
      items.map((t, i) => {
        let childs = t.Childs || [];
        let count = t.ChildCount || 0;
        let icon = this.getIcon(FolderIcon, t.Id);
        return (
          <TreeItem onClick={() => { this.onClick(childs, count, t.Id); }} key={i} nodeId={`${t.Id}`} labelText={t.Name} labelIcon={icon} >
            {/* 先进行判断是否存在子目录数据，如果有就显示，没有再进行判断子目录数量是否大于0，如果有就显示loading效果，否则null */}
            {!Util.empty(childs) ? this.renderItems(t.Childs) : (count ? <TreeLoading /> : null)}
          </TreeItem>)
      })
    )
  }

  getIcon(defaultIcon, id) {
    let { openIds } = this.state;
    if (openIds == null) return defaultIcon;
    return openIds.filter((t) => t == id).length > 0 ? FolderOpenIcon : FolderIcon;
  }

  render() {
    let { data, rootId } = this.props;
    let { items, openIds } = this.state;
    items = items || data || [];

    let icon = this.getIcon(FolderOpenIcon, rootId);
    return (
      <TreeView
        onNodeToggle={(e, ids) => { this.setState({ openIds: ids }) }}
        defaultExpanded={[`${rootId}`]}
        defaultCollapseIcon={<ArrowDropDownIcon />}
        defaultExpandIcon={<ArrowRightIcon />}
      >
        <TreeItem onClick={() => { this.onClick(null, null, rootId); }} nodeId={`${rootId}`} labelText={"根目录"} labelIcon={icon} >
          {this.renderItems(items)}
        </TreeItem>
      </TreeView>
    );
  }

}
